import { useSalvcarContext } from "@/app/contexts/SalvcarContext";
import { Button } from "@/view/components/ui/button";
import { DialogClose, DialogContent } from "@/view/components/ui/dialog";
import { TickCircle } from "iconsax-react";

export default function ProposalSuccessModal() {
  const { setCustomerData } = useSalvcarContext();

  const handleClearProposalData = () => {
    setCustomerData(null);
  };

  return (
    <DialogContent className="max-h-[740px] overflow-y-auto p-6 sm:max-w-2xl">
      <div className="mt-10 flex flex-col items-start gap-1.5 px-6">
        <TickCircle variant="Bold" size={40} className="text-success" />
        <strong className="font-semibold">Proposta realizada</strong>
        <p className="text-sm font-medium text-black04">
          A proposta está em andamento, você receberá uma notificação caso a
          transação for concluída.
        </p>
      </div>
      <div className="mt-6 flex justify-end">
        <DialogClose asChild>
          <Button
            className="w-[200px] rounded-full px-8 py-3 font-semibold text-white"
            onClick={handleClearProposalData}
          >
            Voltar para o início
          </Button>
        </DialogClose>
      </div>
    </DialogContent>
  );
}
